import { GET_DELIVERY_ORDERS } from "./actionTypes";
import { EMPTY_DELIVERY_ORDERS } from "./constants";

const initialState = {
  delivery_orders: { ...EMPTY_DELIVERY_ORDERS },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_DELIVERY_ORDERS:
      return { ...state, delivery_orders: action.payload };
    default:
      return state;
  }
}
